import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TrustedBy from '../components/TrustedBy';
import achemaImage from '../assets/achema.jpg';
import danfossImage from '../assets/danfoss.jpg';
import batImage from '../assets/bat.jpg';
import './CaseStudies.css';

const CaseStudies = () => {
  const { t } = useTranslation();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const caseStudies = [
    {
      title: t('caseStudies.achema.title'),
      industry: t('caseStudies.achema.industry'),
      description: t('caseStudies.achema.description'),
      descriptionExtended: t('caseStudies.achema.descriptionExtended'),
      resultsIntro: t('caseStudies.achema.resultsIntro'),
      results: t('caseStudies.achema.results', { returnObjects: true }),
      image: achemaImage,
    },
    {
      title: t('caseStudies.danfoss.title'),
      industry: t('caseStudies.danfoss.industry'),
      description: t('caseStudies.danfoss.description'),
      descriptionExtended: t('caseStudies.danfoss.descriptionExtended'),
      resultsIntro: t('caseStudies.danfoss.resultsIntro'),
      results: t('caseStudies.danfoss.results', { returnObjects: true }),
      image: danfossImage,
    },
    {
      title: t('caseStudies.bat.title'),
      industry: t('caseStudies.bat.industry'),
      description: t('caseStudies.bat.description'),
      descriptionExtended: t('caseStudies.bat.descriptionExtended'),
      resultsIntro: t('caseStudies.bat.resultsIntro'),
      results: t('caseStudies.bat.results', { returnObjects: true }),
      image: batImage,
    },
  ];

  return (
    <div className="case-studies-page">
      <section className="page-header">
        <div className="header-container">
          <h1>{t('nav.caseStudies')}</h1>
          <p>{t('caseStudies.subtitle')}</p>
        </div>
      </section>

      <section className="case-studies-section">
        <div className="studies-container">
          <div className="studies-grid">
            {caseStudies.map((study, index) => {
              const isExpanded = expandedIndex === index;
              return (
                <div key={index} className="case-card">
                  <div className="case-card-top">
                    {study.image && (
                      <div className="case-image">
                        <img 
                          src={study.image} 
                          alt={study.title} 
                          loading="lazy"
                          decoding="async"
                        />
                      </div>
                    )}
                    <div className="case-content">
                      <div className="case-industry">{study.industry}</div>
                      <h3>{study.title}</h3>
                      <p>
                        {study.description}
                        {' '}
                        {!isExpanded && (
                          <span 
                            className="read-more-link"
                            onClick={() => setExpandedIndex(index)}
                          >
                            {t('caseStudies.readMore', 'Read More')}
                          </span>
                        )}
                      </p>
                      {isExpanded && study.descriptionExtended && (
                        <p className="description-extended">
                          {study.descriptionExtended}
                          {' '}
                          <span 
                            className="read-more-link"
                            onClick={() => setExpandedIndex(null)}
                          >
                            {t('caseStudies.readLess', 'Read Less')}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className={`case-results-section ${isExpanded ? 'expanded' : ''}`}>
                    <div className="case-results-wrapper">
                      {study.resultsIntro && (
                        <p className="results-intro">{study.resultsIntro}</p>
                      )}
                      <div className="case-results">
                        {study.results.map((result, idx) => (
                          <div key={idx} className="result-item">
                            <span className="check">•</span>
                            <span>{result}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <TrustedBy />
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
